import { Injectable, inject } from '@angular/core';
import {
  MachineHistorySettings,
  MachineHistorySettingsApi,
  settingsDefaults,
  machineHistoryColumnsBaseConfig,
} from './machine-history-settings.api';
import { SettingsServiceBase } from 'src/services';
import { MachineHistory } from './machine-history.model';
import { configToSettingsColumnTitles } from '../config-utils';

@Injectable()
export class MachineHistorySettingsService extends SettingsServiceBase<
  keyof MachineHistory,
  MachineHistorySettings,
  MachineHistorySettingsApi
> {
  constructor() {
    const settingsApi = inject(MachineHistorySettingsApi);

    super(
      settingsApi,
      configToSettingsColumnTitles(machineHistoryColumnsBaseConfig),
      settingsDefaults
    );
  }
}
